//
//
//
//
//
//

import enquiryStatusConfig from '@/config/enquiryStatus.config';

export default {
    props: {
        status: {
            type: String,
            required: true,
        },
    },
    computed: {
        config() {
            if (enquiryStatusConfig[this.status]) {
                return enquiryStatusConfig[this.status];
            }

            return {
                color: 'grey-3',
                textColor: 'primary',
                text: this.status,
            };
        },
    },
};
